/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Workout_Quick_Done_LabelInputs */

const en_us2_workout_quick_done_label = /** @type {(inputs: Workout_Quick_Done_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Done: ${i?.name}`)
};

const pt_br2_workout_quick_done_label = /** @type {(inputs: Workout_Quick_Done_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Feito: ${i?.name}`)
};

const es_419_workout_quick_done_label = /** @type {(inputs: Workout_Quick_Done_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hecho: ${i?.name}`)
};

const pt_pt2_workout_quick_done_label = /** @type {(inputs: Workout_Quick_Done_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Feito: ${i?.name}`)
};

const fr_fr2_workout_quick_done_label = /** @type {(inputs: Workout_Quick_Done_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fait : ${i?.name}`)
};

const de_de2_workout_quick_done_label = /** @type {(inputs: Workout_Quick_Done_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erledigt: ${i?.name}`)
};

const it_it2_workout_quick_done_label = /** @type {(inputs: Workout_Quick_Done_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fatto: ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Done: {name}" |
*
* @param {Workout_Quick_Done_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_quick_done_label = /** @type {((inputs: Workout_Quick_Done_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Quick_Done_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_quick_done_label(inputs)
	if (locale === "es-419") return es_419_workout_quick_done_label(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_quick_done_label(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_quick_done_label(inputs)
	if (locale === "de-DE") return de_de2_workout_quick_done_label(inputs)
	if (locale === "it-IT") return it_it2_workout_quick_done_label(inputs)
	return en_us2_workout_quick_done_label(inputs)
});
export { workout_quick_done_label as "workout-quick.done_label" }